export default __webpack_public_path__ + "static/media/Visa.caceba91.svg";